import {
    ADD_REMOTE_USER,
    REMOVE_REMOTE_USER,
    OPEN_REMOTE_REPORTS_MODAL,
} from '../actions/actionTypes'

const initialState = {
    remotelyReports: false,
    remoteCashBoxId: null,
    remoteUserId: null,
}

const remotelyReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_REMOTE_USER:
            return {
                ...state,
                remoteCashBoxId: action.payload.remoteCashBoxId,
                remoteUserId: action.payload.remoteUserId,
            }
        case REMOVE_REMOTE_USER:
            return {
                ...state,
                remotelyReports: false,
                remoteCashBoxId: null,
                remoteUserId: null,
            }
        case OPEN_REMOTE_REPORTS_MODAL:
            return {
                ...state,
                remotelyReports: true
            }
        default:
            return state
    }
}

export default remotelyReportsReducer